import React, { Component } from 'react'
import Error from './Error'
import PropTypes from 'prop-types'

class ErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.element.isRequired
  }

  constructor (props) {
    super(props)
    this.state = { error: null }
  }

  componentDidCatch (error) {
    this.setState({ error })
  }

  render () {
    if (this.state.error) {
      return <Error />
    }

    return this.props.children
  }
}

export default ErrorBoundary
